export const getFilteredData = (data = [], viewType, timeframe) => {
    const baseData = viewType === "cumulative" ? getCumulativeData(data) : data;
    if (timeframe === "all") return baseData;

    const weeks = parseInt(timeframe);
    if (isNaN(weeks)) return baseData;

    return baseData.slice(-weeks);
};

export const getCumulativeData = (data = []) => {
    const cumulative = [];
    let runningTotals = {};

    data.forEach((week = {}) => {
        const cumulativeWeek = { ...week };
        const fields = [
            "CollabsBilled",
            "AffiliateBilled",
            "ScaledBilled",
            "AppDownloads",
            "TotalAutoPaid",
            "TotalManualPaid",
        ];

        fields.forEach((field) => {
            const currentValue = Number(week?.[field]) || 0;
            runningTotals[field] = (runningTotals[field] || 0) + currentValue;
            cumulativeWeek[`${field}_Cumulative`] = runningTotals[field];
        });

        cumulative.push(cumulativeWeek);
    });

    return cumulative;
};

export const formatCurrency = (value) => {
    const num = Number(value) || 0;
    if (num >= 1e7) return `₹${(num / 1e7).toFixed(1)}Cr`;
    if (num >= 1e5) return `₹${(num / 1e5).toFixed(1)}L`;
    if (num >= 1e3) return `₹${(num / 1e3).toFixed(1)}K`;
    return `₹${num}`;
};

export const formatNumber = (value) => {
    const num = Number(value) || 0;
    if (num >= 1e6) return `${(num / 1e6).toFixed(1)}M`;
    if (num >= 1e3) return `${(num / 1e3).toFixed(1)}K`;
    return num.toString();
};

export const getWeekOverWeekChange = (filteredData = [], metric) => {
    if (!Array.isArray(filteredData) || filteredData.length < 2) return 0;

    const current = Number(filteredData.at(-1)?.[metric]) || 0;
    const previous = Number(filteredData.at(-2)?.[metric]) || 0;

    if (previous === 0) return 0;
    return ((current - previous) / previous) * 100;
};

export const getMetricConfig = (selectedMetric, viewType) => {
    const isCumulative = viewType === "cumulative";

    const configs = {
        financial: {
            title: "Financial Performance",
            metrics: isCumulative
                ? [
                      "CollabsBilled_Cumulative",
                      "AffiliateBilled_Cumulative",
                      "ScaledBilled_Cumulative",
                  ]
                : ["CollabsBilled", "AffiliateBilled", "ScaledBilled"],
            formatter: formatCurrency,
            colors: ["#3B82F6", "#10B981", "#F59E0B"],
        },
        creators: {
            title: "Creator Growth",
            metrics: [
                "TotalSignedCreators",
                "TotalAffiliates",
                "TotalCreatorPros",
                "TotalActiveCreators",
            ],
            formatter: formatNumber,
            colors: ["#8B5CF6", "#06B6D4", "#84CC16", "#F97316"],
        },
        engagement: {
            title: "Engagement Metrics",
            metrics: [
                "StoresViewed",
                "StoresCreated",
                "CollabsViewed",
                "CollabsEngaged",
            ],
            formatter: formatNumber,
            colors: ["#EF4444", "#EC4899", "#6366F1", "#14B8A6"],
        },
        tools: {
            title: "Tool Usage",
            metrics: ["DailyVisits", "LinkitVisits", "QRVisits", "ScoreVisits"],
            formatter: formatNumber,
            colors: ["#F59E0B", "#10B981", "#3B82F6", "#8B5CF6"],
        },
        conversions: {
            title: "Conversion Rates",
            metrics: [
                "StoreConversion",
                "CollabConversion",
                "DailyConversion",
                "LinkitConversion",
            ],
            formatter: (value) => `${(Number(value) || 0).toFixed(1)}%`,
            colors: ["#059669", "#DC2626", "#7C3AED", "#DB2777"],
        },
        payments: {
            title: "Payment Analytics",
            metrics: isCumulative
                ? ["TotalAutoPaid_Cumulative", "TotalManualPaid_Cumulative"]
                : ["TotalAutoPaid", "TotalManualPaid"],
            formatter: formatCurrency,
            colors: ["#10B981", "#F59E0B"],
        },
        targets: {
            title: "Target Achievement",
            metrics: ["CollabsTarget", "AffiliateTarget", "ScaledTarget"],
            formatter: formatCurrency,
            colors: ["#3B82F6", "#10B981", "#F59E0B"],
        },
    };

    return (
        configs?.[selectedMetric] || {
            title: "Unknown",
            metrics: [],
            formatter: formatNumber,
            colors: [],
        }
    );
};
